export default __webpack_public_path__ + "static/media/black-book.54b0e34c.png";